// =====================================================================
//  DATAS INDISPONÍVEIS (semanas já reservadas)
// =====================================================================
//
//  Para BLOQUEAR datas: acrescenta uma linha dentro de [ ... ] no formato
//      { from: "AAAA-MM-DD", to: "AAAA-MM-DD" },
//  Os dois dias (from e to) ficam bloqueados, inclusive.
//
//  Exemplo — bloquear de 4 a 11 de Agosto de 2026:
//      { from: "2026-08-04", to: "2026-08-11" },
//
//  Para um único dia, põe a mesma data nos dois:
//      { from: "2026-08-15", to: "2026-08-15" },
//
//  Para DESBLOQUEAR: apaga a linha correspondente.
//
//  (Lista vazia = tudo disponível a partir de 1 de Julho de 2026.)
// =====================================================================

export const BLOCKED_RANGES = [
  // { from: "2026-08-04", to: "2026-08-11" },
];
